import { render, staticRenderFns } from "./ChangeCardsWithNumbers.vue?vue&type=template&id=656c79d0"
import script from "./ChangeCardsWithNumbers.vue?vue&type=script&lang=js"
export * from "./ChangeCardsWithNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports